import { PageHeader } from '@fukuri-admins/ui/common';

type Props = {
  /** 利用者氏名 */
  fullName: string;
  /** 利用者一覧ページのURL */
  indexHref: string;
};

/**
 * 利用者編集ヘッダーの Presentation コンポーネント
 * パンくずリスト付きページヘッダーを表示する
 */
export const EditUserHeaderPresentation: React.FC<Props> = ({ fullName, indexHref }) => (
  <PageHeader
    variant='breadcrumb'
    breadcrumbItems={[{ label: '利用者一覧', href: indexHref }, { label: `${fullName}の編集` }]}
  />
);
